import mockPlayer from './attach-builder-mock-player';

const state = {
  // Build state variables.
  mobileFormVisible: true,
  currentStep: 0,
  currentStepIsValid: false,
  currentMode: null,
  hasSaveError: false,

  // Player details.
  mockPlayer: mockPlayer,
  currentPlayerModel: false,
  playerHasBeenEdited: false,

  // Cosmetic only params
  objectOfProductsForDisplayOnly: undefined,
  focusedProductForInspection: undefined,
  currentAttachBrand: undefined,

  // Credentials - QUESTION: Can we move this to main module?
  actingUserId: false,
  actingBrandId: false,
};

const mutations = {
  updateMobileFormVisible(state, visible) {
    state.mobileFormVisible = visible;
  },
  setCreateVsEditMode(state, mode) {
    state.currentMode = mode;
  },
  updateAttachBuilderStep(state, step) {
    state.currentStep = step;
  },
  createCurrentPlayerModelInState(state, object) {
    state.currentPlayerModel = object;
  },
  updateParamOnCurrentPlayerModel(state, object) {
    if (!object.key) return;
    if (!state.currentPlayerModel) state.currentPlayerModel = {};

    // Player has been edited. Toggling to true allows player to be saved now.
    state.playerHasBeenEdited = true;

    const key = object.key;
    const value = object.value;

    // Player will only update if the entire object is reassigned, so we
    // make a copy of player, update it, then assign it as new value in state.
    const modelCopy = JSON.parse(JSON.stringify(state.currentPlayerModel));

    // Add the value to the product.
    modelCopy[key] = value;

    // Update the model on the state.
    state.currentPlayerModel = modelCopy;
  },
  setActingUserId(state, id) {
    state.actingUserId =id;
  },
  setActingBrandId(state, id) {
    state.actingBrandId = id;
  },
  updateProductDisplayObject(state, object) {
    state.objectOfProductsForDisplayOnly = object;
  },
  addProductToProductDisplayObject(state, product) {
    if (!product || !product.id) return;

    if (!state.objectOfProductsForDisplayOnly) {
      state.objectOfProductsForDisplayOnly = {};
    }

    state.objectOfProductsForDisplayOnly[product.id] = product;
  },
  updateFocusedProductForInspection(state, productId) {
    state.focusedProductForInspection = productId;
  },
  setVariantCustomization(state, object) {
    const product = JSON.parse(JSON.stringify(state.focusedProductForInspection));

    const sku = object.sku;
    const key = object.key;
    const value = object.value;

    if (!product.customizations) product.customizations = {};
    if (!product.customizations[sku]) product.customizations[sku] = {};

    product.customizations[sku][key] = value;

    state.focusedProductForInspection = product;
  },
  updateCurrentBrand(state, brand) {
    state.currentAttachBrand = brand;
  },
  setHasSaveError(state, error) {
    state.hasSaveError = error;
  },
};

const actions = {
  setCurrentBrandData({ commit, dispatch }, brand) {
    if (brand && brand.brandId) {
      commit('updateCurrentBrand', brand);
      commit('setActingBrandId', brand.brandId);

      window.localStorage.setItem('mmPlatformBrandIdFilter', brand.brandId);

      dispatch('setDisabledLinks', brand);
    }
  },
  setDisabledLinks(_, brand) {
    const disabledLinks = [];

    if (!brand.isDashboardDemographicsEnabled) disabledLinks.push('Shopper Intelligence');
    if (!brand.enableSalesDashboard) disabledLinks.push('Sales Insights');

    window.dispatchEvent(
      new CustomEvent('disabled-links:changed', {
        detail: {
          disabledLinks,
        },
      }),
    );
  },
};

const module = {
  state: state,
  mutations: mutations,
  actions,
};

export default module;
